import { WPPost } from '../types/wordpress';

const STORAGE_KEY = 'orbcon_recently_viewed';
const MAX_ITEMS = 10;

/**
 * Get recently viewed resources from localStorage
 */
export function getRecentlyViewed(): WPPost[] {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return [];
    
    const parsed = JSON.parse(stored);
    // Ensure it's an array and has valid post data
    return Array.isArray(parsed) ? parsed.filter(post => post && post.id) : [];
  } catch (error) {
    console.error('Error reading recently viewed:', error);
    return [];
  }
}

/**
 * Add a resource to recently viewed
 */
export function addToRecentlyViewed(post: WPPost): void {
  try {
    const recent = getRecentlyViewed();
    
    // Remove if already exists (to avoid duplicates)
    const filtered = recent.filter(p => p.id !== post.id);
    
    // Add to beginning
    const updated = [post, ...filtered].slice(0, MAX_ITEMS);
    
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch (error) {
    console.error('Error saving recently viewed:', error);
  }
}

/**
 * Clear recently viewed resources
 */
export function clearRecentlyViewed(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Error clearing recently viewed:', error);
  }
}

